import PropertiesConstants from '../../../constants/PropertiesConstants';

import { AccordionCardList } from '../../../components/AccordionCardList';

import PropertiesListCard from './PropertiesListCard';

import type { AccountViewListingGroupDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { ExpandedGroups } from '../../../hooks/useExpandedGroups';

type Props = {
  listingGroups: Array<AccountViewListingGroupDto>;
  isLoading?: boolean;
  expansion: ExpandedGroups;
  registerCard?: (id: string, node: HTMLLIElement | null) => void;
};

const createSkeletonListing = (index: number): AccountViewListingGroupDto =>
  ({
    groupId: `skeleton-${index}`,
    listingAlias: `skeleton-${index}`,
    name: '',
    photoKey: '',
    address: { street: '', city: '', state: '', zip: '', unit: '' },
  }) as AccountViewListingGroupDto;

export const PropertiesListCards = ({ listingGroups, isLoading = false, expansion, registerCard }: Props) => {
  const showSkeletons = isLoading && listingGroups.length === 0;

  const items = showSkeletons
    ? Array.from({ length: PropertiesConstants.PROPERTIES_LIMIT_DEFAULT }, (_, index) => createSkeletonListing(index))
    : listingGroups;

  return (
    <AccordionCardList
      data-testid="FlexiblePropertyCardList"
      ariaLabel="Properties"
      expansion={expansion}
      registerCard={registerCard}
      items={items}
      getItemId={(listing) => listing.groupId}
      renderCard={(listing, isExpanded) => (
        <PropertiesListCard listing={listing} isExpanded={isExpanded} isLoading={showSkeletons} />
      )}
    />
  );
};
